<template>
  <app-modal width="40%" name="external-invoice-modal" hide-footer :title="$t('invoice.external-invoice.invoiceLookup')"
    @before-open="beforeOpen">
    <div class="external-invoice-content">
      <p v-if="!genderLinkLookup">{{ $t('invoice.external-invoice.noSupplierInfo') }}</p>
      <div v-else>
        <div class="px-4">
          <p class="text-muted">
            {{ $t('invoice.external-invoice.pleaseClickLink') }}
          </p>

          <div class="section-box p-3 d-flex hustify-content-between align-items-center">
            <div class="flex-grow-1">
              <p class="text-secondary mb-1" style="font-size: 13px;">{{ $t('invoice.external-invoice.linkNCC') }}:</p>
              <p class="text-primary font-weight-bold mb-0" style="word-break: break-all;">
                <a :href="genderLinkLookup" target="_blank">
                  {{ genderLinkLookup }}
                  <i class="ml-2 fa fa-external-link"></i>
                </a>
              </p>
            </div>
          </div>

          <h5 class="mt-4 font-weight-bold d-flex align-items-center">
            <span class="material-symbols-outlined mr-2 text-warning">
              <i class="fa fa-key"></i>
            </span>
            {{ $t('invoice.external-invoice.infoLookup') }}
          </h5>
          <div class="section-box p-3 mt-3 d-flex justify-content-between align-items-center">
            <div>
              <p class="text-secondary mb-1" style="font-size: 12px;">{{ $t('invoice.external-invoice.taxCode') }}: </p>
              <p class="font-weight-bold mb-0">{{ genderTaxCode }}</p>
            </div>
            <button class="copy-btn" @click="copyTaxCode">
              <i class="fa fa-clone"></i>
            </button>
          </div>

          <div class="section-box p-3 mt-3 d-flex justify-content-between align-items-center">
            <div>
              <p class="text-secondary mb-1" style="font-size: 12px;">{{ $t('invoice.external-invoice.secretCode') }}:
              </p>
              <p class="font-weight-bold mb-0">{{ genderSecretCode }}</p>
            </div>
            <button class="copy-btn" @click="copySecretCode">
              <i class="fa fa-clone"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
</template>
<script>
import AppModal from '@/components/app-modal/';
import ToastUtils from '@/utils/toast';
import { PROVIDER_INFORMATION } from '@/app-constant';

export default {
  name: 'ExternalInvoiceModal',
  components: { AppModal },
  data() {
    return {
      taxCode: '',
      secretCode: '',
    };
  },
  computed: {
    company() {
      return PROVIDER_INFORMATION.find(company => company.taxCode === this.taxCode);
    },
    genderLinkLookup() {
      return this.company ? this.company.linkLookup : '';
    },
    genderTaxCode() {
      return this.company ? this.company.taxCode : '';
    },
    genderSecretCode() {
      return this.secretCode;
    }
  },
  methods: {
    beforeOpen(params) {
      const { taxCode, secretCode } = params.model;
      this.taxCode = taxCode;
      this.secretCode = secretCode;
      if (!this.company) {
        this.$modal.hide('external-invoice-modal');
        ToastUtils.showToast('error', this.$t('invoice.external-invoice.toast.dataFetchError'));
        return;
      }
    },
    async copyTaxCode() {
      try {
        await navigator.clipboard.writeText(this.genderTaxCode);
        ToastUtils.showToast('success', this.$t('invoice.external-invoice.toast.taxCodeCopied'));
      } catch (err) {
        ToastUtils.showToast('error', this.$t('invoice.external-invoice.toast.copyError'));
      }
    },
    async copySecretCode() {
      try {
        await navigator.clipboard.writeText(this.genderSecretCode);
        ToastUtils.showToast('success', this.$t('invoice.external-invoice.toast.secretCodeCopied'));
      } catch (err) {
        ToastUtils.showToast('error', this.$t('invoice.external-invoice.toast.copyError'));
      }
    }

  },
};
</script>
<style lang="scss" scoped>
.external-invoice-content {
  p {
    margin-bottom: 1rem;

    a {
      font-weight: bolder;
    }
  }

  .section-box {
    background: #F2F2F2;
    border-radius: 12px;
  }

  .copy-btn {
    background: #FFF;
    border: 1px solid #DDD;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgb(0 143 255 / 45%);
    transition: 0.3s ease-out;

    i {
      color: #005DCA;
    }

    &:hover {
      box-shadow: 0px 0px 10px rgb(0, 145, 255);

      i {
        color: #0077ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/external-invoice-modal.vue